module.exports = __webpack_public_path__ + "img/tmp-michel.26fbfa92.svg";